"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[837],{

/***/ 71837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B2BPage": function() { return /* binding */ B2BPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75102);
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21776);
/* harmony import */ var _components_layouts_b2b_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78506);
/* harmony import */ var _components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22135);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77868);






const B2BPage = (props)=>{
    var ref, ref1;
    const { page , model  } = props;
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .bU)();
    return(// https://www.builder.io/c/docs/ab-data-models#getting-the-correct-variation
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_b2b_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        page: page,
        model: model,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.title,
                description: page === null || page === void 0 ? void 0 : (ref1 = page.data) === null || ref1 === void 0 ? void 0 : ref1.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .BuilderContent */ .Ku, {
                model: model,
                content: page,
                children: (variant, loading, content)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_1__/* .BuilderComponent */ .VD, {
                        locale: locale,
                        model: model,
                        entry: page === null || page === void 0 ? void 0 : page.id,
                        content: content,
                        data: {
                            ...(0,_builder__WEBPACK_IMPORTED_MODULE_2__/* .getBlockDataMap */ .LV)({
                                data: variant
                            }),
                            ...variant || {}
                        }
                    }, page === null || page === void 0 ? void 0 : page.id);
                }
            }, page === null || page === void 0 ? void 0 : page.id)
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (B2BPage);


/***/ })

}]);